import React from "react";
import { Button } from "react-bootstrap";
import PracticeScore from "./PracticeScore";
import withSubscriptionCheckButton from "../../../../components/Common/withSubscriptionCheckButton";

// Helper function to round scores to at most 1 decimal place
const roundScore = (score) => {
  if (typeof score === "number") {
    return Math.round(score * 10) / 10;
  }
  return score;
};

const StartButton = withSubscriptionCheckButton(
  Button,
  "Practice",
  true,
  false
);

const PracticeSetItem = ({
  practice,
  onStart,
  roleOfTheUser,
  classroomId,
  activeTab,
  practiceInd,
  hasValidSubscription,
  focusedExam,
}) => {

  const isPending = practice?.gradingStatus?.length && practice?.gradingStatus !== 'graded' && (practice?.type === 'writing' || practice?.type === 'speaking')
  return (
    <div
      className="d-flex align-items-center justify-content-between px-4"
      style={{
        height: "60px",
        borderBottom: "1px solid #E1E1E1",
        background: practice?._id === focusedExam ? "#e8e8e8" : "",
      }}
    >
      <div className="practice-set-info d-flex align-items-center gap-3">
        <div
          style={{
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "22px",
            letterSpacing: "-0.01em",
            textAlign: "left",
            color: "#1B2128",
          }}
        >
          {practice?.name}
        </div>
        {practice?.score ? (
          <PracticeScore score={roundScore(practice?.score)} type={practice?.type} />
        ) : (
          <span
            className="score-badge"
            style={{
              padding: "4px 12px",
              borderRadius: "20px",
              fontSize: "11px",
              fontWeight: 600,
              backgroundColor: isPending ? "#FEE2E2" : "#F3F4F6",
              color: isPending ? "#991B1B" : "#6B7280",
              border: isPending ? "1px solid #FECACA" : "1px solid #E5E7EB",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
            }}
          >
            {isPending ? 'Pending': practice?.score !== null && practice?.score !== undefined
              ? `${roundScore(practice?.score)}%`
              : "Unattempted"}
          </span>
        )}
      </div>
      <div>
        {roleOfTheUser === "Student" ? (
          <StartButton
            onClick={onStart}
            classRoomId={classroomId}
            requiredFeature="Practice"
            hasValidSubscription={hasValidSubscription}
            subjects={[activeTab]}
            index={practiceInd}
          >
            Start
          </StartButton>
        ) : (
          <Button
            onClick={onStart}
            className="start-classroom-styles"
            variant="outline-primary"
          >
            Start
          </Button>
        )}
      </div>
    </div>
  );
};

export default PracticeSetItem;
